import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/self-storage-solution.jpg'),
    alt: 'self storage solution page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'self storage solution page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Self Storage</span><span>Solutions Available Now</span>',
  description:
    'Discover secure, affordable, and flexible self-storage solutions for all your personal and business needs. Store your belongings with confidence and access them whenever required.',
  image: {
    url: '/images/v2/pages/landing-pages/self-storage-solution/hero-image.jpg',
    alt: 'Reliable Self Storage Solutions Available Now'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Self Storage Solutions' }
}

export const ourProcessSectionContent = {
  title: 'How Our Self Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/self-storage-solution/how-our-self-storage-solutions-work.png',
    alt: 'How Our Self Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Hassle-Free Booking',
      description: 'Reserve your storage unit online in minutes with a straightforward booking process.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-solution/hassle-free-booking.png',
        alt: 'Hassle-Free Booking'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Units',
      description: 'Our facilities offer climate-controlled, secure units equipped with 24/7 surveillance.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-solution/secure-storage-units.png',
        alt: 'Secure Storage Units'
      }
    },
    {
      id: 3,
      title: 'Flexible Access',
      description: 'Access your stored items at your convenience with extended hours and easy entry.',
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-solution/flexible-access.png',
        alt: 'Flexible Access'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast And Reliable Self Storage Solutions',
  description:
    'We provide customizable, reliable, and safe storage options, designed to meet the needs of homeowners, businesses, and students alike.',
  image: {
    src: '/images/v2/pages/landing-pages/self-storage-solution/fast-and-reliable-self-storage-solutions.jpg',
    alt: 'Fast And Reliable Self Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Self Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Affordable Storage Plans',
      description: 'Choose from a variety of budget-friendly pricing options to suit your storage requirements.',
      image: {
        src: '/images/v2/pages/common/affordable-storage-plans.png',
        alt: 'Affordable Storage Plans'
      }
    },
    {
      id: 2,
      title: 'Enhanced Security',
      description: 'Keep your belongings safe with advanced features such as gated access and monitored surveillance.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Enhanced Security'
      }
    },
    {
      id: 3,
      title: 'Variety of Unit Sizes',
      description: 'Select the perfect unit size, from small lockers to large spaces for bulky items.',
      image: {
        src: '/images/v2/pages/common/space-saving-solutions.png',
        alt: 'Variety of Unit Sizes'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Self Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description: 'Store household items, furniture, and seasonal belongings with ease.'
        },
        {
          id: 2,
          title: 'Businesses',
          description: 'Secure inventory, documents, and office equipment with flexible storage options.'
        },
        {
          id: 3,
          title: 'Students',
          description: 'Take advantage of affordable storage for belongings during school breaks or relocations.'
        },
        {
          id: 4,
          title: 'Travelers',
          description: "Keep personal items safe while you're on the move or between destinations."
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/self-storage-solution/who-should-use-our-self-storage-solutions.jpg',
        alt: 'Who Should Use Our Self Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Storage Services',

  cards: [
    {
      id: 1,
      title: 'Personal Storage Units',
      description: 'Store furniture, clothing, and valuables securely and conveniently.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Personal Storage Units'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Student Storage Options',
      description: 'Affordable and flexible storage tailored for students’ unique needs.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'Student Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage Solutions',
      description: 'Keep your workspace clutter-free with secure storage for business needs.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Vehicle Storage Solutions',
      description: 'Securely store your car, motorcycle, or recreational vehicles in our monitored facilities.',
      image: {
        src: '/images/v2/pages/common/vehicle-storage.png',
        alt: 'Vehicle Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Self-Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/self-storage-solution/why-choose-us-for-self-storage-solutions.jpg',
    alt: 'Why Choose Us for Self-Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Wide Range of Units',
      description: 'From compact to oversized units, we have the perfect solution for your storage needs.'
    },
    {
      id: 2,
      title: 'Flexible Terms',
      description: 'Choose short-term or long-term rental options without worrying about contracts.'
    },
    {
      id: 3,
      title: 'Climate-Controlled Units',
      description: 'Preserve sensitive items like electronics, documents, and artwork in optimal conditions.'
    },
    {
      id: 4,
      title: 'Local Accessibility',
      description: 'Find storage units conveniently located near you for hassle-free access.'
    },
    {
      id: 5,
      title: 'Advanced Security Features',
      description: '24/7 video surveillance, gated access, and alarm systems keep your items safe.'
    },
    {
      id: 6,
      title: 'Exceptional Customer Service',
      description: 'Our team is ready to assist you at every step for a smooth storage experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Self-Storage Solutions Reliable and Affordable',
  description:
    'Reliable self-storage solutions for your needs. Affordable, fast, and secure services for storing personal or business items.',
  image: {
    src: '/images/v2/pages/landing-pages/self-storage-solution/self-storage-solutions-reliable-and-affordable.png',
    alt: 'Self-Storage Solutions Reliable and Affordable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started Now' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description: 'We collaborate with industry-leading shipping providers to offer seamless logistics support.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures timely and secure shipping for your stored items, whether local or international.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in global shipping, ensuring efficient transport of your belongings to or from our facilities.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers fast, reliable shipping solutions tailored for storage needs, with a strong global presence.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
